import { component_tool, framework_tool, utils_tool } from '@/tool';
import React from 'react';

import { WizTableForm } from '@/containers/common';

const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 } })
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1 } })
const positionCategoryConfig = WizTableForm.Config.positionCategory()
let { WizModal,WizButton,WizDataTable} = component_tool;
//配置项
let componentName = 'procTaskDone';

const columns =  [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "任务名称",
    name: "name",
    dataIndex: "name",
    searchItem:{},
    tableItem: {
      width: 200,}
  },

  {
    title: "业务类型",
    name: "processDefKey",
    dataIndex: "processDefKey",
    dict: [
      { code: "ApplyCommon", codeName: "公共报名" },
      { code: "Process", codeName: "测试流程" },
      { code: "Leave", codeName: "请假" },
    ],
    searchItem: {
      type: "select"
    },
    tableItem: {
      width: 100,
      type: "select"
    }
  },
  // {
  //   title: "所属流程",
  //   name: "processDefName",
  //   dataIndex: "processDefName",
  //   tableItem: {}
  // },
  {
    title: "申请人",
    name: "applyer",
    dataIndex: "applyer",
    tableItem: {
      width: 100,}
  },
  {
    title: "申请人任职",
    name: "userIdentityInfo",
    dataIndex: "userIdentityInfo",
    tableItem: {
      width: 400,}
  },
  // {
  //   title: "耗时",
  //   name: "duration",
  //   dataIndex: "duration",
  //   tableItem: {}
  // },
  {
    title: "开始时间",
    name: "startTime",
    dataIndex: "startTime",
    tableItem: {
      width: 150,}
  },
  {
    title: "结束时间",
    name: "endTime",
    dataIndex: "endTime",
    tableItem: {
      width: 150,}
  },
  {
    title: "组织机构",
    name: "organizationIdList",
    searchItem: {
      ...organizationConfig,
      diy: WizTableForm,
    }
  },
  {
    title: "岗位",
    name: "positionIdList",
    searchItem: {
      ...positionConfig,
      diy: WizTableForm,
    }
  },
  {
    title: "岗位分类",
    name: "positionCategoryId",
    searchItem: {
      ...positionCategoryConfig,
      selectType: 'radio',
      diy: WizTableForm,
      initialValue: undefined
    }
  },
];

const templateConfig = {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns:columns,
        searchBarProps: {
          cols: {
            xs: 24,
            md: 12,
            xl: 8
          },
          buttonSort:['delete'],
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          loading: false
        },
        rowOperateSort:['reviewInfo'],
        rowOperateView: [
          {
            key: "reviewInfo",
            custom: true,
            params: { children: "审核信息"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/workflow/auditHistory",
              },
            },
          }
        ],
        commonOperate: {}
      }
    }
};

const apis = {
  list: {
    path: `${componentName}/listByPage`,
    payload: {
      key: `${componentName}@listByPage`,
    }
  },
}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig }
